import React from 'react';
import './SupportSection.css';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const SupportSection: React.FC = () => {
  const { ref: sectionRef, style: sectionStyle } = useScrollAnimation<HTMLElement>({ delay: 0.1 });
  const { ref: cardRef, style: cardStyle } = useScrollAnimation<HTMLDivElement>({ delay: 0.2 });
  const { ref: labelRef, style: labelStyle } = useScrollAnimation<HTMLSpanElement>({ delay: 0.3 });
  const { ref: titleRef, style: titleStyle } = useScrollAnimation<HTMLHeadingElement>({ delay: 0.4 });
  const { ref: textRef, style: textStyle } = useScrollAnimation<HTMLParagraphElement>({ delay: 0.5 });
  const { ref: benefitsRef, style: benefitsStyle } = useScrollAnimation<HTMLDivElement>({ delay: 0.6 });
  const { ref: ctaRef, style: ctaStyle } = useScrollAnimation<HTMLDivElement>({ delay: 0.7 });

  return (
    <section className="support-section" id="support" ref={sectionRef} style={sectionStyle}>
      <div className="support-container">
        <div className="support-card" ref={cardRef} style={cardStyle}>
          <div className="card-glow"></div>
          <div className="card-content">
            <span className="section-label" ref={labelRef} style={labelStyle}>Support</span>
            <h2 className="support-title" ref={titleRef} style={titleStyle}>Want to Speed Things Up?</h2>
            
            <p className="support-text" ref={textRef} style={textStyle}>
              If you want to help me move faster, please hit me up to make a private donation. 
              It will go a long way.
            </p>

            <div className="benefits-list" ref={benefitsRef} style={benefitsStyle}>
              <h3>What your support enables:</h3>
              <ul>
                <li>
                  <span className="check-icon">✓</span>
                  Consistent marketing for all future coins
                </li>
                <li>
                  <span className="check-icon">✓</span>
                  Strategic planning and execution
                </li>
                <li>
                  <span className="check-icon">✓</span>
                  Strong narratives that stand out
                </li>
                <li>
                  <span className="check-icon">✓</span>
                  Apps I'm personally developing
                </li>
              </ul>
            </div>

            <div className="support-cta" ref={ctaRef} style={ctaStyle}>
              <p className="cta-text">Ready to be part of the journey?</p>
              <a href="https://x.com" target="_blank" rel="noopener noreferrer" className="contact-button">
                <span className="button-text">Get in Touch</span>
                <span className="arrow">→</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SupportSection;